import { ComparisonOperator } from "@evergis/ui";

import { FILLED_OPERATORS } from "../components/LayerFilter/constants";

export const checkEmptyOrFilled = (comparisonOperator: ComparisonOperator): boolean => {
  return FILLED_OPERATORS.includes(comparisonOperator);
};
